<template>
	<div>
		<h1>Benutzer</h1>
		<button @click="editFrm(0)"><i class="fas fa-plus"></i> Hinzufügen</button>
		<table>
			<thead>
				<th>UID</th>
				<th>Name</th>
				<th>Status</th>
				<th></th>
				<th></th>
			</thead>
			<tbody>
				<tr v-for="(rec,idx) in recs" :key="idx">
					<td>{{ rec.uid }}</td>
					<td>{{ rec.name }}</td>
					<td><span class="badge" :class="rec.active === '1' ? 'active' : 'locked'">{{ rec.active === '1' ? 'aktiv' : 'gesperrt' }}</span></td>
					<td><i class="fas fa-pencil-alt" @click="editFrm(rec.id)"></i></td>
					<td><i class="fas fa-trash-alt" @click="deleteConfirm(rec.id)"></i></td>
				</tr>
			</tbody>
		</table>
		
		<modal name="modalDel" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Löschung bestätigen</div>
			<div class="delConf-content">
				Benutzer '{{ delUserName }}' wirklich löschen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="deleteRec" class="delConf-btn-del">Löschen</button>
				<button @click="$modal.hide('modalDel')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalEdit" width="500" height="auto" :clickToClose="false" draggable=".delConf-title" @opened="$refs.uuz_uid.focus()">
			<div class="delConf-title">Benutzer bearbeiten</div>
			<div class="delConf-content">
				<label for="uuz_uid">Benutzer ID (UID)</label><input type="text" id="uuz_uid" ref="uuz_uid" v-model="edit.uid"><br>
				<label for="uuz_name">Name</label><input type="text" id="uuz_name" v-model="edit.name"><br>
				<label for="uuz_admin">Admin</label><input type="checkbox" id="uuz_admin" v-model="edit.admin"><br>
				<label for="uuz_active">Aktiv</label><input type="checkbox" id="uuz_active" v-model="edit.active"><br>
				<hr>
				<label for="uuz_pwd1">Passwort</label><input type="password" id="uuz_pwd1" v-model="edit.pwd"><br>
				<label for="uuz_pwd2">Passwort bestätigen</label><input type="password" id="uuz_pwd2" v-model="edit.pwd_check">
			</div>
			<div class="delConf-button-wrapper">
				<button @click="saveRec">Speichern</button>
				<button @click="$modal.hide('modalEdit')">Abbrechen</button>
			</div>
		</modal>
		<vue-snotify></vue-snotify>
	</div>
</template>

<script>
/*
1 	id	 		smallint(5)
2 	name 		varchar(255)
3 	uid 		varchar(255)
4 	pwd 		varchar(255)
5 	active 		tinyint(1)
6 	admin 		tinyint(1)
7 	deleted		datetime
8 	deleted_by 	smallint(5)
*/
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'

  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			id: 0,
			delUserName: '',
			edit: {
				name: '',
				uid: '',
				pwd: '',
				pwd_check: '',
				active: true,
				admin: false
			},
			recs: []
		}
	},
    methods: {
      deleteConfirm: function (id) {
		var vm = this
		vm.id = parseInt(id)
		
		vm.delUserName = 'unknown'
        vm.$_.forEach(vm.recs, function (value) {
			if (value.id == id) {
				vm.delUserName = value.name
				return false
			}
	    })
		
        vm.$modal.show('modalDel')
      },
      deleteRec: function () {
		this.$modal.hide('modalDel')
		this.apiCall([{method: 'core/user/delete', param: {id: this.id}, id: 10},{method: 'core/user/list', param: {}, if: [{id: 10, path: 'result/success', eq: true}], id: 5}], this.evalApiResponse)
      },
      saveRec: function () {
		//TODO: Sicherstellen dass PWD1 und PWD2 identisch sind!!
		var param = {
			id: this.id,
			name: this.edit.name,
			uid: this.edit.uid,
			active: this.edit.active ? 1 : 0,
			admin: this.edit.admin ? 1 : 0
		}
		if (this.edit.pwd !== '') param['pwd'] = this.edit.pwd

		this.apiCall([{method: 'core/user/save', param: param, id: 15},{method: 'core/user/list', param: {}, if: [{id: 15, path: 'result/success', eq: true}], id: 5}], this.evalApiResponse)
      },
      editFrm: function (id) {
		this.id = parseInt(id)
		if (this.id === 0) {
			this.edit = {
				name: '',
				uid: '',
				pwd: '',
				pwd_check: '',
				active: true,
				admin: false
			}
			this.$modal.show('modalEdit')
		} else {
			//TODO: Laden und anschl. Modal anzeigen
			this.edit.pwd = this.edit.pwd_check = ''
			this.apiCall([{method: 'core/user/load', param: {"id": this.id}, id: 7}], this.evalApiResponse)
		}
      },
      evalApiResponse: function (resp) {
        var vm = this
        this.$_.forEach(resp, function (value) {
          if (value.hasOwnProperty('id')) {
            switch (value.id) {
              case 5: // 5 = Result from '.../list'
		  console.log('greetings from evalApiResponse')
				vm.recs = value.result
                break
              case 7: // 7 = Result from '.../load'
                if (value.hasOwnProperty('error')) {
                } else {
                  if (value.hasOwnProperty('result') && value.result.hasOwnProperty('name')) {
                    vm.edit.name = value.result.name
                    vm.edit.uid = value.result.uid
                    vm.edit.active = parseInt(value.result.active) === 1
                    vm.edit.admin = parseInt(value.result.admin) === 1
					vm.$modal.show('modalEdit')
                  }
                }
                break
              case 10: // 10 = Result from '.../delete'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
				}
                break
              case 15: // 15 = Result from '.../save'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
                } else {
					vm.$modal.hide('modalEdit')
					vm.$snotify.success('Benutzerdaten gespeichert', 'OK')
				}
                break
            }
          }
        })
      }
    },
    mounted: function () {
//		console.log('greetings from mounted')
		this.apiCall([{method: 'core/user/list', param: {}, id: 5}], this.evalApiResponse)
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

td:nth-child(1) {min-width: 100px}
td:nth-child(2) {min-width: 200px}
td:nth-child(3) {text-align: center}

th:nth-child(3) {text-align: center}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

td > i {
	cursor: pointer;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.active {
	background: #080;
}

.badge.locked {
	background: #c00;
}

/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

/*EDIT DIALOG*/
.delConf-content label {
	display: inline-block;
	width: 200px;
}

.delConf-content input[type=text], .delConf-content input[type=password] {
	width: 250px;
	border: 1px solid #888;
	margin-bottom: 5px;
	padding:3px;
}

hr {
    border: none;
    height: 1px;
    color: #333; /* old IE */
    background-color: #333; /* Modern Browsers */
}
</style>
